import * as React from "react"
import { SVGProps, memo } from "react"

const CheckCircle = memo((props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        {...props}
    >
        <circle cx={8} cy={8} r={7} fill="#50AC86" stroke="none" />
        <path
            d="M6 8L7.5 9.5L11 6"
            stroke="white"
            strokeWidth={1.5}
        />
    </svg>
))

export default CheckCircle